export const filterExercisesByDiagnoseId = <T extends { diagnoses: { diagnose: { id: number } }[] }>(
    list: T[],
    id: number
): T[] => list.filter((item) => item.diagnoses.some(({ diagnose }) => diagnose.id === id))
